<template>
	<a-card>
		<a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
			<template #message>
				已选择 {{ selectedRowKeys.length }} 项
				<a @click="onClearSelected" class="ml-20 float-right">清空</a>
			</template>
		</a-alert>
		<a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
			:pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
			<template #companyName="{ record }">
				<a @click="onCompanyDetail(record)">{{ record.companyName }}</a>
			</template>
			<template #jobTitle="{ record }">
				<dict-render :dict-obj="dictObjs['hope_job']" :text="record.jobTitle"></dict-render>
			</template>
			<template #action="{ record }">
				<div class="table-row-operations">
					<div class="hidden">{{ record.id }}</div>
					<a @click="onDetail(record)" v-if="record.isPass == 0">接受邀请</a>
					<span v-if="record.isPass != 0">{{ record.isPass == '1' ?'已接受': '已拒绝' }}</span>
				</div>
			</template>
		</a-table>
	</a-card>
	<DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @onCloseModel="onFormEdited" />
	<CompanyDetailModal ref="companydetailModal" :form-primary-key-field="listKeyField" />
</template>

<script>
import CompanyDetailModal from './components/companyDetailModal';
import DetailModal from './components/DetailModal';
import { dictMixin, tableListMixin } from "@/mixins";
import { talentUserViewInfo } from "@/api/educationService";
import { companyInfo } from "@/api/companyService";
import DictRender from "@/components/other/DictRender";
import { dateFormat } from "@/config/variableConfig";
import { showCity } from "@/utils/util";

const columns = [
	// {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
	{ title: "企业名称", dataIndex: "companyName", key: "companyName", slots: { customRender: "companyName" } },
	{ title: "职位名称", dataIndex: "jobTitle", key: "jobTitle", slots: { customRender: "jobTitle" } },
	{ title: "联系人", dataIndex: "contactName", key: "contactName" },
	{ title: "联系电话", dataIndex: "contactNumber", key: "contactNumber" },
	{ title: "邀请时间", dataIndex: "createdTime", key: "createdTime" },
	{ title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
	name: "index",
	mixins: [tableListMixin, dictMixin],
	components: {
		DictRender, CompanyDetailModal, DetailModal
	},
	data() {
		return {
			dateFormat,
			dictNames: 'research_field,education_background,salary,work_experience,hope_job',
			columns,
			queryParamFixed: { type: 1 },
			listUrl: talentUserViewInfo.pageList,
			listKeyField: "id",
		}
	},
	methods: {
		onCompanyDetail(record) {
			this.getAction({
				url: companyInfo.detail,
				params: { companyCode: record.companyCode }
			}).then(res => {
				let obj = {
					...res,
					provject: showCity(res.prov, res.city, res.dist)
				}
				this.onShowModal('companydetailModal', obj);
			})
		},
		onDetail(record) {
			this.getAction({
				url: companyInfo.detail,
				params: { companyCode: record.companyCode }
			}).then(res => {
				let obj = {
					...res,
					provject: showCity(res.prov, res.city, res.dist),
					interviewInvitationId: record.interviewInvitationId
				}
				this.onShowModal('detailModal', obj);
			})
		},
	}
}
</script>

<style scoped></style>
